import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './components/header/Header';
import './showcase.scss';
import SideBar from './components/sidebar/SideBar';
import TradeIn from './trade-in/TradeIn';
import CreditScore from './credit-score/CreditScore';
import LeadGen from './lead-gen/LeadGen';

const ShowCase: React.FC = () => {
  const navigate = useNavigate();
  const { widgetName } = useParams<{ widgetName: string }>();

  const components: Record<string, JSX.Element> = {
    'trade-in': <TradeIn />,
    'credit-score': <CreditScore />,
    'lead-gen': <LeadGen />,
  };

  const selectedName = widgetName ? widgetName.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : 'Trade In';

  const handleSelect = (item: string) => {
    const formattedName = item.toLowerCase().replace(/\s+/g, '-');
    navigate(`/show-case/${formattedName}`);
  };

  return (
    <>
      <Header />
      <div className='container-showcase'>
        <div className='main-block'>
          <SideBar
            items={Object.keys(components).map((key) =>
              key.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
            )}
            selectedItem={selectedName}
            onSelect={handleSelect}
          />
          <div className='main-content'>{widgetName && components[widgetName]}</div>
        </div>
      </div>
    </>
  );
};

export default ShowCase;
